namespace Gamification.Gamification {
    export interface UtentiProdottiEsperienzeTaskForm {
        IdUtenteProdottoEsperienza: Serenity.IntegerEditor;
        IdProdottoEsperienzaTask: Serenity.IntegerEditor;
        DataOraInizio: Serenity.DateEditor;
        DataOraFine: Serenity.DateEditor;
        Stato: Serenity.IntegerEditor;
    }

    export class UtentiProdottiEsperienzeTaskForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdottiEsperienzeTask';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiEsperienzeTaskForm.init)  {
                UtentiProdottiEsperienzeTaskForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;

                Q.initFormType(UtentiProdottiEsperienzeTaskForm, [
                    'IdUtenteProdottoEsperienza', w0,
                    'IdProdottoEsperienzaTask', w0,
                    'DataOraInizio', w1,
                    'DataOraFine', w1,
                    'Stato', w0
                ]);
            }
        }
    }
}
